// extracted by mini-css-extract-plugin
module.exports = {"bottomLine":"Index_bottomLine__2lwV1","video":"Index_video__1N72I","videoBox":"Index_videoBox__3DZoG","close":"Index_close__2v7pg"};